/* tslint:disable */
/* eslint-disable */
/**
 * Vipps ePayment Internal API
 * The Vipps ePayment Internal api
 *
 * The version of the OpenAPI document: 0.9.0
 * Contact: teamecom@vipps.no
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Amount,
    AmountFromJSON,
    AmountFromJSONTyped,
    AmountToJSON,
} from './Amount';

/**
 * 
 * @export
 * @interface Transaction
 */
export interface Transaction {
    /**
     * 
     * @type {Amount}
     * @memberof Transaction
     */
    amount: Amount;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    returnUrl: string;
}

export function TransactionFromJSON(json: any): Transaction {
    return TransactionFromJSONTyped(json, false);
}

export function TransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Transaction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': AmountFromJSON(json['amount']),
        'returnUrl': json['returnUrl'],
    };
}

export function TransactionToJSON(value?: Transaction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': AmountToJSON(value.amount),
        'returnUrl': value.returnUrl,
    };
}

